import { render, staticRenderFns } from "./AddStepSimpleText.vue?vue&type=template&id=65f44ac3&"
import script from "./AddStepSimpleText.vue?vue&type=script&lang=js&"
export * from "./AddStepSimpleText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports